import React from 'react';
import Typical from 'react-typical';
import { Link } from 'react-router-dom';
import './Home.css';


const Home=()=>{
    return(
        <section className="home" id="home">
            <div className="max-width">
                <div className="home-content">
                    <div className="text-1">Hello, my name is</div>
                    <div className="text-2">Rutvik Patel</div>
                    <div className="text-3">And I'm a<span className="Typing">{''}
                    <Typical
                        steps={["Learner",1000,
                        "Systems Developer",1000, 
                        "Enthusiastic Person", 1000,
                        "Explorer",1000, 
                        "Team player",1000
                    ]}
                        loop={Infinity}
                        wrapper="p"
                      />
                      </span></div>
                    <Link to="/Contact">Hire me</Link>
                </div>
            </div>
        </section>
    );
};


export default Home;
